import { App } from "@system/App";
 
import { addClassToElement, removeClassFromElement } from "@utils/helpers";
 
enum ScreenType {
    PORTRAIT = 'PORTRAIT',
    LANDSCAPE = 'LANDSCAPE',
    DESKTOP = 'DESKTOP'
  }

  
export class Layout {
  static isPortrait() {
    return App.getHeight() >= App.getWidth();
  }
  
  static isWidthLessThan(value: number){
    return App.getWidth() <= value
  }


  static isLandscape() {
    return (
      App.getHeight() <= 400 ||
      (App.getWidth() >= App.getHeight() && App.getWidth() < 1000)
    );
  }

  static isDesktop() {
    return App.getWidth() >= App.getHeight() && App.getWidth() > 1200;
  }

  static isPortraitScreen() {
    return window.innerHeight >= window.innerWidth;
  }

  static isLandscapeScreen() {
    let maxHeightLandscape = 400;
  
    return (
      window.innerHeight <=  maxHeightLandscape ||
      (window.innerWidth >= window.innerHeight && window.innerWidth <= 1200)
    );
  }

  static isDesktopScreen() {
    return (
      window.innerWidth >= window.innerHeight &&
      window.innerWidth < 1600 &&
      window.innerWidth > 1200
    );
  }

  static isLargeDesktopScreen() {
    return window.innerWidth >= window.innerHeight && window.innerWidth >= 1600;
  }


  static IsDesktopOrLargeDesktop(){
    return Layout.isDesktopScreen() || Layout.isLargeDesktopScreen();
  }

 


  static isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || (navigator as any).msMaxTouchPoints > 0;
  }

  static resize() {
    const betInput = document.getElementById("bet-input") as HTMLInputElement;
    if (Layout.isPortraitScreen()) {
      document.body.classList.add("portrait");
      document.body.classList.remove("landscape");
      document.body.classList.remove("desktop");
      document.body.classList.remove("large-desktop");
      // betInput?.setAttribute("readonly", "readonly");
    } else if (Layout.isLandscapeScreen()) {
      document.body.classList.add("landscape");
      document.body.classList.remove("portrait");
      document.body.classList.remove("desktop");
      document.body.classList.remove("large-desktop");
      // betInput?.setAttribute("readonly", "readonly");
    } else
    if (Layout.isDesktopScreen()) {
      document.body.classList.add("desktop");
      document.body.classList.remove("landscape");
      document.body.classList.remove("portrait");
      document.body.classList.remove("large-desktop");
      // betInput?.removeAttribute("readonly");
    } else  if (Layout.isLargeDesktopScreen()) {
      document.body.classList.add("large-desktop");
      document.body.classList.remove("desktop");
      document.body.classList.remove("landscape");
      document.body.classList.remove("portrait");
      // betInput?.removeAttribute("readonly");
    }
  }

  static getScreenType(): ScreenType {
    return Layout.isPortrait()
      ? ScreenType.PORTRAIT
      : Layout.isLandscape()
      ? ScreenType.LANDSCAPE
      : ScreenType.DESKTOP;
  }

 

 

  static showElement(element: HTMLElement) {
    removeClassFromElement(element, "hide");
  }

  static hideElement(element: HTMLElement) {
    addClassToElement(element, "hide");
  }
}

 
